import { useSelector } from "react-redux";
import { RootState } from "@features/store/store";

const useLanguages = () => useSelector((state: RootState) => state.languages.languages);

const useIsLanguagesLoading = () => useSelector((state: RootState) => state.languages.isLanguagesLoading);
const useLanguagesRestoreData = () => useSelector((state: RootState) => state.languages.languagesRestoreData);
const useIsViewRestoreLanguage = () => useSelector((state: RootState) => state.languages.isViewRestoreLanguage);
const useDefaultLanguage = () => useSelector((state: RootState) => state.languages.defaultLanguage);

export { useLanguages, useIsLanguagesLoading, useIsViewRestoreLanguage, useLanguagesRestoreData, useDefaultLanguage };
